var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRemoveFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79499 8.99953L11.52 7.27453C11.7375 7.05703 11.7375 6.69703 11.52 6.47953C11.3025 6.26203 10.9425 6.26203 10.725 6.47953L8.99999 8.20453L7.27499 6.47953C7.05749 6.26203 6.69749 6.26203 6.47999 6.47953C6.26249 6.69703 6.26249 7.05703 6.47999 7.27453L8.20499 8.99953L6.47999 10.7245C6.26249 10.942 6.26249 11.302 6.47999 11.5195C6.59249 11.632 6.73499 11.6845 6.87749 11.6845C7.01999 11.6845 7.16249 11.632 7.27499 11.5195L8.99999 9.79453L10.725 11.5195C10.8375 11.632 10.98 11.6845 11.1225 11.6845C11.265 11.6845 11.4075 11.632 11.52 11.5195C11.7375 11.302 11.7375 10.942 11.52 10.7245L9.79499 8.99953Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRemoveFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-remove-file.788b3f82655df4087bb293c0333bf482.svg";